<template>
  <UserFavourites v-slot="{ favourites }">
    <FavouriteDropdown :favourites="favourites" v-slot="{ toggle }">
      <div class="NavGuestFavourite pt-8">
        <div class="flex" :class="$mq | mq({ md: 'hidden' })">
          <button @click="toggle" class="ml-auto text-danger text-3xl px-2">&times;</button>
        </div>
        <strong class="block uppercase text-center text-lg text-grey-dark mb-8">
          <i class="far fa-heart mr-4" data-fa-transform="grow-2"></i>
          Unsaved Favourites ({{ favourites.length }})
        </strong>

        <div class="bg-grey-light p-8">
          <p class="text-center text-lg font-bold">Save your favourites</p>
          <p class="mt-2 text-center">Enter your email to sync favourites on all devices.</p>
          <OnboardingForm :onboardPath="onboardPath" />
        </div>

        <div class="NavGuestFavourite__items p-8" v-if="favourites.length > 0">
          <FavouriteItem v-for="listing in favourites" :key="listing.id" :listing="listing" />
        </div>
      </div>
    </FavouriteDropdown>
  </UserFavourites>
</template>

<script>
import FavouriteDropdown from "./FavouriteDropdown.vue"
import FavouriteItem from "./FavouriteItem.vue"
import UserFavourites from "../../UserFavouritesRenderless.js"
import OnboardingForm from "./OnboardingForm.vue"

export default {
  name: "Nav.Guest.Favourite",
  props: {
    onboardPath: {
      type: String,
      required: true,
    },
  },
  components: {
    FavouriteDropdown,
    FavouriteItem,
    UserFavourites,
    OnboardingForm,
  },
  mounted() {
    const ssrNavGuestFavourite = document.getElementById("ssr-nav-guest-favourite")
    ssrNavGuestFavourite.classList.add("hidden")
  },
}
</script>

<style scoped>
.NavGuestFavourite__items {
  overflow-y: auto;
  max-height: 280px;
}
</style>
